import React, { memo, useMemo, useCallback } from "react";
import pluralize from "pluralize";
import Icon from "../Icons/Icon";
import AxiomSelect from "__AxiomComponents/AxiomSelect/AxiomSelect.jsx";
import "./HawkeyeV2PostHeading.scss";

function HawkeyeV2PostHeading(props) {
  const { conversations, onAddPost, filters, setFilters, allCollaborators } = props;
  const applyFilter = (type) => {
    const newFilters = { ...filters };
    if (type === "dueWeek") {
      newFilters.isDueThisWeek = !newFilters.isDueThisWeek;
    } else if (type === "allConversations") {
      newFilters.isAllConversations = true;
      newFilters.isOpenConversations = false;
      newFilters.isCloseConversations = false;
    } else if (type === "openedConversations") {
      newFilters.isAllConversations = false;
      newFilters.isOpenConversations = true;
      newFilters.isCloseConversations = false;
    } else if (type === "closedConversations") {
      newFilters.isAllConversations = false;
      newFilters.isOpenConversations = false;
      newFilters.isCloseConversations = true;
    }
    setFilters(newFilters);
  };

  const completedPosts = useMemo(() => {
    let noOfCompletedPosts = 0;
    conversations.forEach((d) => {
      if (d.isCompleted) {
        ++noOfCompletedPosts;
      }
    });
    return noOfCompletedPosts;
  }, [conversations]);

  const changeSelectedCollaborator = useCallback(
    (key, value) => {
      const newFilters = { ...filters };
      newFilters.selectedCollaborator = value;
      setFilters(newFilters);
    },
    [filters, setFilters]
  );

  return (
    <div>
      <div className="hawkeye-conversations-posts-heading">
        <div className="hawkeye-conversations-top-filters">
          <span>
            {conversations.length > 0
              ? pluralize("conversation", conversations.length, true)
              : "No conversations"}
          </span>
          <button
            onClick={() => applyFilter("dueWeek")}
            className={`hawkeye-conversations-heading-filter ${
              filters.isDueThisWeek ? "selected" : ""
            }`}
          >
            Due in this week
          </button>
          <div className="hawkeye-conversations-assignee-selection">
            <span className="hawkeye-conversations-assignee-label">Assigned: </span>
            <AxiomSelect
              value={filters.selectedCollaborator}
              options={allCollaborators}
              onChange={changeSelectedCollaborator}
              multiSelect={false}
              placeholder={"Select Assignee"}
              className={"hawkeye-assignee-selection-dropdown"}
            />
          </div>
        </div>
        <button onClick={onAddPost} className="hawkeye-btn hawkeye-btn-secondary">
          <Icon className="hawkeye-conversations-post-icon" icon="ICON_PLUS" />
          <span>Add a new</span>
        </button>
      </div>
      {conversations.length > 0 && (
        <div className="hawkeye-conversations-filter-tags">
          <button
            onClick={() => applyFilter("allConversations")}
            className={`hawkeye-conversations-heading-filter tag ${
              filters.isAllConversations ? "selected" : ""
            }`}
          >
            {`All Conversations (${conversations.length})`}
          </button>
          <button
            onClick={() => applyFilter("openedConversations")}
            className={`hawkeye-conversations-heading-filter tag ${
              filters.isOpenConversations ? "selected" : ""
            }`}
          >
            {`Open Conversations (${conversations.length - completedPosts})`}
          </button>
          <button
            onClick={() => applyFilter("closedConversations")}
            className={`hawkeye-conversations-heading-filter tag ${
              filters.isCloseConversations ? "selected" : ""
            }`}
          >
            {`Closed Conversations (${completedPosts})`}
          </button>
        </div>
      )}
    </div>
  );
}

export default memo(HawkeyeV2PostHeading);
